<template>
  <div style="display: flex; flex-direction: column">
    <div class="inline-flex items-baseline q-mb-xs">
      <div class="pos-row">
        <template v-if="id > 0 && !hideInfoBtn">
          <app-icon
            class="pos-row__info q-mr-xs"
            name="info-circle-outline"
            width="18px"
            color="#979797"
            hover-color="#499259"
            cursor="pointer"
            :title="$t('info')"
            @click="showPosInfoMode = true"
          />
          <q-dialog v-model="showPosInfoMode" no-shake :full-width="true">
            <item-addition-component
              :existing-position-id="id"
              @close="showPosInfoMode = false"
            />
          </q-dialog>
        </template>

        <parameter-inline-display
          :id="'ds_' + id"
          :editable="false"
          :is-table="false"
          :model-value="el"
        />
      </div>
      <app-icon
        v-if="!hideRemoveBtn"
        class="ml-1 pos-row__remove"
        name="close"
        width="16px"
        color="#979797"
        hover-color="#616161"
        cursor="pointer"
        :title="$t('remove')"
        @click.stop="detach"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-facing-decorator";
import { ParameterInstanceContainer } from "../../../../models/interfaces/parameters/parameter-models";
// import ItemAdditionComponent from "../ItemAdditionComponent.vue";
import ParameterInlineDisplay from "../ParameterInlineDisplay.vue";
import AppIcon from "@/components/ui-kit/icon/AppIcon.vue";

@Component({
  name: "PositionRow",
  components: { ParameterInlineDisplay, AppIcon },
  emits: ["detach"],
})
export default class PositionRow extends Vue {
  // === PROPS ===
  @Prop({ type: Number, default: 0 }) readonly id!: Number;
  @Prop({ required: true }) readonly el!: ParameterInstanceContainer[];
  @Prop({ type: Boolean, default: false }) readonly hideInfoBtn!: boolean;
  @Prop({ type: Boolean, default: true }) readonly hideRemoveBtn!: boolean;

  showPosInfoMode = false;

  detach() {
    this.$emit("detach", null);
  }
}
</script>

<style lang="scss" scoped>
.pos-row {
  display: inline;
}

.pos-row :deep(.green-text) {
  color: $primary;
  font-weight: 500;
}

.pos-row :deep(.text-medium) {
  font-weight: 500;
}

.pos-row :deep(.text-span) {
  color: $text-color;
  font-style: italic;
}

.inline-flex {
  display: inline-flex;
  align-items: flex-start;
}

.pos-row__info {
  margin-top: -4px;
}

.pos-row__remove {
  margin-top: 1px;
}
</style>
